"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var DeveloperName = function (_a) {
    var name = _a.name;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: "post-developer" },
        react_1.default.createElement("span", { className: "post-developer-name" },
            "\u201C",
            name,
            "\u201D"),
        react_1.default.createElement("span", { className: "post-developer-label" }, t('POST_PREVIEW.BUILDING_NAME_LABEL'))));
};
exports.default = react_1.memo(DeveloperName);
